module.exports = __webpack_public_path__ + "img/google-authenticator.a32459ba.png";